import { render, staticRenderFns } from "./type.vue?vue&type=template&id=d8745fe4&scoped=true&"
import script from "./type.vue?vue&type=script&lang=js&"
export * from "./type.vue?vue&type=script&lang=js&"
import style0 from "./type.vue?vue&type=style&index=0&id=d8745fe4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8745fe4",
  null
  
)

export default component.exports